module.exports = __webpack_public_path__ + "img/icon_verde_17_active.4d32ae6e.png";